import { createSelector } from 'reselect';

const getClosedBatches = (state, props) => state.closedBatches;

export const makeGetSelectedClosedBatch = () =>
    createSelector(
        [getClosedBatches],
        ({ closedBatches, selectedClosedBatch, upcomingClosedBatches }) =>
            closedBatches.find(
                closedBatch => closedBatch.LotId === selectedClosedBatch
            ) || {
                ...upcomingClosedBatches.find(
                    closedBatch => closedBatch.LotId === selectedClosedBatch
                ),
                upcoming: true,
            }
    );
